export default __webpack_public_path__ + "static/media/x1.ec39c606.png";